// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".pill[data-v-7870c942]{color:#fff;font-size:10px;padding:2px 6px;border-radius:9px}@media only screen and (min-width: 737px){.pill[data-v-7870c942]{font-size:12px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
